import React from 'react';

import Record from 'ui/Record/Record';

import { MainHeader } from 'components/MainHeader/MainHeader';

import routes from 'core/routes';

import { useNavBarHeight } from 'utils/hooks/navbar';

import LicensesList from './components/LicensesList';

const Licenses: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();

  return (
    <Record
      Header={
        <MainHeader
          title="Licences"
          breadcrumbs={[
            { label: 'Organisation', link: '' },
            { label: 'Licences', link: routes.dashboard.settings.licenses.toString() },
          ]}
        />
      }
      Content={(onError) => <LicensesList onError={onError} />}
      navBarHeight={navBarHeight}
    />
  );
};

export default Licenses;
